import React, { useState, useEffect } from "react";
import { Container, Col, Row, Button, Form, InputGroup, FormControl, Image } from "react-bootstrap";
import score from '../assets/img/score.png'
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../commons/inFormTypes";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loaders from "../components/Loaders";
import { useSpring, animated } from 'react-spring'
import Ripples from 'react-ripples';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import charity from "../assets/img/charity.png"


function Wallet() {
  const [orgId, setOrgId] = useState(0);
  const [listOrg, setListOrg] = useState([]);
  const [selectFile, setSelectFile] = useState(false);
  const [cartAlert, setCartAlert] = useState(false);
  const [snipCart, setSnipCart] = useState(false);
  const [snipCost, setSnipCost] = useState(false);
  const [snipTransfer, setSnipTransfer] = useState(false);
  const [cartNumber, setCartNumber] = useState();
  const [Stchange, setstchange] = useState(false);
  const [code, setCode] = useState("");
  const [cointTransfer, setCointTransfer] = useState();
  const [transaction, setTransaction] = useState(0);
  const [coint, setCoint] = useState("");
  const [Sumcoint, setsumcoint] = useState("معادل:-");
  const [convertId, setConvertId] = useState(0);
  const [convertText, setConvertText] = useState("");
  const [seenFile, setSeenFile] = useState([]);
  const [listTransaction, setListTransaction] = useState([]);
  const userToken = localStorage.getItem("user_token");
  const coints = Intl.NumberFormat('en-US').format(parseFloat(localStorage.getItem("Coints")));
  const navigate = useNavigate();
  
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const orgBtn = useSpring({
    background: selectFile
      ? "#E78E09"
      : "#ced4da",

  });

  const personBtn = useSpring({
    background: selectFile
      ? "#ced4da"
      : "#E78E09",
  });

  const personClicked = () => {
    setSelectFile(false);
    // setCointTransfer("");
    // setCode("");
  }

  const orgClicked = () => {
    setSelectFile(true);
    setCointTransfer("");
    setCode("");
  }



  useEffect(() => {
    if (userToken === null) {
      navigate("/");
    } else {
      const axios = require("axios");
      axios
        .post(apiUrl + "Get_ListCoints", {
          TokenId: userToken,
          Type: transaction,
          Code_Meli: ""
        })

        .then((res) => {
          if (res.data.result === "true") {
            setCartNumber(res.data.data_Users.CardNumber)
            setSeenFile(res.data.data_Convert);
            setListTransaction(res.data.data);
            //  let sk = "100/1000/10";
          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });


      axios
        .post(apiUrl + "Get_Organization", {
          TokenId: userToken,
          Code_Meli: "",
          Type: 0
        })

        .then((res) => {
          if (res.data.result === "true") {

            setListOrg(res.data.data)
          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }

  }, [Stchange, transaction]);

  const selectAreaHandler = (e) => {
    setConvertId(e.target.value);
    setConvertText(e.target.options[e.target.selectedIndex].text);
    let code = e.target.value.split("/")[1];//معادل مبلغ هر آیتم
    let count = e.target.value.split("/")[2];//تعداد هر آیتم به ازای مبلغ معادل پایه آن
    if (coint !== "" && coint !== null)
      setsumcoint((coint / code) * count)//تعداد هر آیتم به ازای مبلغ کل نوشته شده
  }

  const CointHandler = (e) => {
    setCoint(e.target.value);
    let code = convertId.split("/")[1];
    let count = convertId.split("/")[2];
    if (e.target.value !== "" && coint !== null && convertId !== "0") {
      setsumcoint(" معادل : " + (e.target.value / code) * count)
    } 
    else
      setsumcoint(" معادل : -")
  }

  const convertHandler = (val) => {
    let coint1 = 0;
    if (val === 0) {
      coint1 = coint;
      if (coint === "" || convertId === 0) {
        toast.error("لطفا اطلاعات مورد نظر را وارد کنید", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        return false;
      }
    } else if (val === 1) {
      coint1 = cointTransfer;
      if (selectFile === false && (code === "" || cointTransfer === "")) {
        toast.error("لطفا اطلاعات مورد نظر را وارد کنید", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        return false;
      } else if (selectFile === true && (orgId === 0 || cointTransfer === "")) {
        toast.error("لطفا مبلغ و موسسه مورد نظر را وارد کنید", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        return false;
      }

    }

    const axios = require("axios");
    if (val === 0) {
      setSnipCost(true);
    } else {
      setSnipTransfer(true)
    }

    axios
      .post(apiUrl + "Insert_Score", {
        Coint: coint1,
        Type: val,
        Code: convertId,
        Tittle: convertText,
        Code_Dist:  selectFile === true ? orgId :0,
        TokenId: userToken,
        Code_Meli: "",
      })
   

      .then((res) => {
        if (val === 0) {
          setSnipCost(false);
        } else {
          setSnipTransfer(false)
        }

        if (res.data.result === "true") {
          if (Stchange)
            setstchange(false)
          else
            setstchange(true)

          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });

  }

  const submitCartHandler = () => {

    if (cartNumber === null || cartNumber.length < 24) {
      toast.error("لطفا شماره شبا صحیح را وارد کنید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      return false;
    }

    const axios = require("axios");
    setSnipCart(true);
    axios
      .post(apiUrl + "Insert_Card", {
        TokenId: userToken,
        Code_Meli: "",
        CardNumber: cartNumber,
      })

      .then((res) => {
        setSnipCart(false);
        if (res.data.result === "true") {
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }

  const creditHandler = (e) => {
    setCartNumber(e.target.value);
    if (cartNumber.length === 23) {
      setCartAlert(true)
    } else {
      setCartAlert(false)
    }
  };


  return (
    <div>
      <Container>
        <Row className="justify-content-center mb-3">
          <Col xs={11} lg={9} className="mt-3">
            <Row className="justify-content-center  g-3">
              <Col xs={12}>
                <Row className="rgc-card  rgc-score-card justify-content-center align-items-center">
                  <Col xs={6} md={5} className="rgc-score-titr text-center">
                    <span>مبلغ کاربری شما:</span>
                  </Col>

                  <Col xs={3} md={2} className="rgc-score-title">
                    <h4>{coints}</h4>
                    {/* <span>ریال</span> */}
                  </Col>
                  <Col xs={3} md={2} className="rgc-item-img">
                    <img src={score}
                      alt=""
                      className="rgc-img-dash img-fluid" />
                  </Col>
                </Row>
              </Col>

              <Col xs={12}>
                <Row className="justify-content-center rgc-score-items">

                  <Col xs={12} md={6} className="text-center text-md-end">
                    <Form.Group className="rgc-input-icons text-center " >
                      <Form.Label>
                        شماره شبا جهت واریزی نقدی(شماره شبا باید به نام خودتان باشد)
                      </Form.Label>
                      <InputGroup className="mb-1 rgc-input">
                        <InputGroup.Text id="basic-addon1" className="rgc-code">IR</InputGroup.Text>
                        <FormControl
                          autoComplete="off"
                          type="number"
                          // className="rgc-code"
                          className="rgc-input-card rgc-time"
                          id="formBasicDate2"
                          value={cartNumber}
                          maxLength={24}
                          onChange={(e) => creditHandler(e)}
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>

                  <Col xs={12} className="text-center pt-4">
                    {cartAlert === true ?
                      <Button
                        className="rgc-orderreg-btn rgc-order-btn-sub"
                        onClick={submitCartHandler}
                      >
                        <Loaders loads={snipCart} />
                        تایید
                      </Button>
                      :
                      <Button
                        disabled
                        className="rgc-orderreg-btn rgc-order-btn-sub"
                        onClick={submitCartHandler}
                      >
                        <Loaders loads={snipCart} />
                        تایید
                      </Button>
                    }

                  </Col>
                </Row>
              </Col>

              <Col xs={12} className="rgc-score-items">
                <Row className="justify-content-center">
                  <Col xs={12} md={7}>
                    <Row className="justify-content-center">
                      <Col xs={6} className="text-start mb-2">
                        <span>دریافت مبلغ به صورت</span>
                      </Col>
                      <Col xs={6} className="mb-2">
                        <Form.Select
                          className="rgc-score-select"
                          value={convertId}
                          onChange={(e) => selectAreaHandler(e)}
                        >
                          <option key={0} value="0">
                            لطفا انتخاب کنید
                          </option>
                          {seenFile.map((data, index) => (
                            <option key={index} value={data.ParaCode + "/" + data.lvl + "/" + data.Oid}>
                              {data.Title}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>

                      <Col xs={6} className="text-start mb-3">
                        <span> مقدار مبلغ</span>
                      </Col>

                      <Col xs={6} className="mb-3">
                        <Form.Group >
                          <Form.Control
                            autoComplete="off"
                            className="rgc-score-input"
                            type="number"
                            placeholder=""
                            value={coint}
                            onChange={(e) => CointHandler(e)}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </Form.Group>
                      </Col>

                      <Col xs={6} className="text-md-center">

                      </Col>

                      <Col xs={6} className="text-center rgc-profile">
                        <span>{Sumcoint}</span>
                      </Col>

                      <Col xs={6} sm={4} className="text-center pt-4 pt-sm-0">
                        <Button className="rgc-orderreg-btn rgc-order-btn-sub"
                          onClick={() => convertHandler(0)} >
                          <Loaders loads={snipCost} />
                          ثبت درخواست
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>

              <Col xs={12} className="rgc-score-items">
                <Row className="justify-content-center">
                  <Col xs={12} md={8} lg={7}>
                    <Row className="justify-content-center align-items-center">

                      <Col xs={12}  className="text-center mb-2">
                        <span>انتقال مبلغ به ریال</span>
                      </Col>

                      <Col xs={10} md={8} className="text-end">
                        <div className="d-flex flex-column">
                          <Form.Group  className="d-flex">
                            {/* <Form.Label className="rgc-score-label text-center m-2">به میزان</Form.Label> */}
                            <Form.Control
                              autoComplete="off"
                              className="rgc-score-input"
                              type="number"
                              placeholder=""
                              value={cointTransfer}
                              onChange={(e) => setCointTransfer(e.target.value)}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          </Form.Group>
                        </div>
                      </Col>
                  
                      <Col xs={8} className="my-3">
                        <Row className="justify-content-center g-0 ">

                          <Col xs={6}  >
                            <animated.button
                              onClick={orgClicked}
                              id="loginBtn"
                              style={orgBtn}
                              className='rgc-select-content rgc-select-content-right'
                            >
                              <span >موسسات خیریه</span>
                            </animated.button>
                          </Col>

                          <Col xs={6} className="rgc-dash-filter">
                            <animated.button
                              className='rgc-select-content rgc-select-content-left'
                              onClick={personClicked}
                              id="registerBtn"
                              style={personBtn}
                            >
                              <span> سایر</span>
                            </animated.button>
                          </Col>
                        </Row>
                      </Col>

                      <Col xs={12}>
                        <Row className="justify-content-center">
                          <Col xs={9}  className={selectFile === false ? "d-block" : "d-none"} >
                            <Form.Group  className="d-flex mt-2">
                              <Form.Label className="rgc-score-label text-center">به کد شماره</Form.Label>
                              <Form.Control
                                autoComplete="off"
                                className="rgc-score-input"
                                type="number"
                                placeholder=""
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </Form.Group>
                          </Col>

                          <Carousel
                            responsive={responsive}
                            centerMode={true}
                            arrows={false}
                          >
                            {listOrg.map((data, index) => {
                              return (

                                <Col xs={9}  key={index} className={selectFile === true ? "d-block m-auto" : "d-none"}>
                                  <Ripples className="rgc-ripple">
                                    <Row className={orgId === data.Code.toString() ?
                                      "justify-content-center g-0 rgc-station-time-select rgc-station-select"
                                      : "justify-content-center g-0 rgc-station-time-select"}>
                                      <Col xs={4} className="text-center">
                                        <div className="radio">
                                          <input
                                            type="radio"
                                            value={data.Code.toString()}
                                            className="rgc-checkbox-select mt-2 me-2"
                                            checked={orgId === data.Code.toString()}
                                            onChange={(e) => setOrgId(e.target.value)}
                                          />
                                        </div>
                                      </Col>

                                      <Col xs={7} className="text-center rgc-address-text">
                                        <div className="d-flex flex-column justify-content-center rgc-checkbox-select-item">
                                          <Image className="rgc-image" src={charity}></Image>
                                          <span>{data.Name}</span>
                                        </div>

                                      </Col>

                                    </Row>
                                  </Ripples>
                                </Col>
                              )
                            })}
                          </Carousel>

                        </Row>
                      </Col>


                      <Col xs={12} className="text-center pt-4">
                        <Button className="rgc-orderreg-btn rgc-order-btn-sub"
                          onClick={() => convertHandler(1)} >
                          <Loaders loads={snipTransfer} />
                          ارسال
                        </Button>
                      </Col>

                    </Row>
                  </Col>


                </Row>
              </Col>

              <Col xs={6}>
                <div className="d-flex rgc-title pt-1">
                  <div className="rgc-title-point"></div>
                  <h4>تمامی <span>تراکنش ها</span></h4>
                </div>
              </Col>

              <Col xs={6} md={3} className="text-start me-auto">
                <Form.Select
                  className="rgc-select"
                  value={transaction}
                  onChange={(e) => setTransaction(e.target.value)}
                >
                  <option value="0">در انتظار تایید </option>
                  <option value="1">تایید شده</option>

                </Form.Select>
              </Col>

              <Col xs={12} className="mt-3">
                <Row className="justify-content-center rgc-score-header">
                  <Col xs={3} className="text-center">
                    <span>مبلغ(ریال)</span>
                  </Col>
                  <Col xs={3} className="text-center">
                    <span>تاریخ تبدیل</span>
                  </Col>
                  <Col xs={6} className="text-center rgc-orderreg-txt">
                    <span>نوع تراکنش</span>
                  </Col>
                </Row>
              </Col>

              {listTransaction.length === 0 ?
                <Col xs={12} className="rgc-orderreg-items rgc-score-body text-center" >
                  <span>تراکنشی موجود نیست</span>
                </Col>
                :
                listTransaction.map((data, index) => {
                  return (
                    <Col xs={12} key={index}>
                      <Row className="justify-content-center rgc-orderreg-items rgc-score-body">
                        <Col xs={3} className="text-center">
                          <span>{data.Coint}</span>
                        </Col>
                        <Col xs={3} className="text-center">
                          <span>{data.Date}</span>
                        </Col>
                        <Col xs={6} className="text-center">
                          {data.Type === 0 ?
                            <span>تبدیل به:<span className="mx-2">{data.Tittle}</span></span>
                            :
                            <span>انتقال به کد:<span className="mx-2">{data.Code_Dist}</span></span>
                          }

                        </Col>
                      </Row>
                    </Col>
                  )
                })}
            </Row>
          </Col>
        </Row>
      </Container >
    </div >
  )
}

export default Wallet